/**
 * @generated SignedSource<<9c8d3db26d544eb7188bf520c5faf213>>
 * @relayHash 223eda78868a326c98d9c170d90b5da9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f81cccca472175339690d4ca0972666654dd3e8de06e57b63ed15e6331038a1f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ClassificationLevelSource = "AUTO" | "CONTENT" | "NONE" | "ORGANIZATION" | "SPACE" | "%future added value";
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type ContentBlogUnifiedQuery$variables = {
  bylineContributorsLimit?: number | null;
  contentId: string;
  includeAgentTrustReceiptData?: boolean | null;
  includeArchiveMetadata?: boolean | null;
  includeBylineContributors?: boolean | null;
  includeClassification?: boolean | null;
  includeReactions?: boolean | null;
  includeRestrictionAncestors?: boolean | null;
  includeRestrictions?: boolean | null;
  isSSR?: boolean | null;
  preloadLabels?: boolean | null;
  spaceKey?: string | null;
  useContentModeFragment?: boolean | null;
  useNewContentTopper?: boolean | null;
  versionOverride?: number | null;
};
export type ContentBlogUnifiedQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly appearancePublished: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly archivedPageBanner?: {
        readonly archivedContentMetadata: {
          readonly archiveNote: string | null;
        } | null;
        readonly history: {
          readonly lastUpdated: {
            readonly by: {
              readonly accountId?: string | null;
            } | null;
          } | null;
        } | null;
        readonly id: string | null;
        readonly operations: ReadonlyArray<{
          readonly operation: string | null;
          readonly targetType: string | null;
        } | null> | null;
        readonly type: string | null;
      } | null;
      readonly archivedPageBannerFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"ArchivedPageBannerV2_content">;
      } | null;
      readonly archivedPageBannerStatusFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"ArchivedPageBannerV2Status_content">;
      } | null;
      readonly body: {
        readonly dynamic: {
          readonly content: {
            readonly id: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null;
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly superbatch: {
              readonly tags: {
                readonly css: string | null;
                readonly js: string | null;
              } | null;
            } | null;
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      readonly contentClassification?: {
        readonly classificationLevelDetails: {
          readonly canManageSpaceSettings: boolean;
          readonly classificationControlSetting: string | null;
          readonly classificationLevel: {
            readonly color: string | null;
            readonly description: string | null;
            readonly guideline: string | null;
            readonly guidelineADF: string | null;
            readonly id: string;
            readonly name: string;
            readonly status: string;
          } | null;
          readonly featureEnabled: boolean;
          readonly isReclassificationPermitted: boolean;
          readonly source: ClassificationLevelSource | null;
          readonly userOverrideSetting: string | null;
        } | null;
        readonly id: string | null;
      } | null;
      readonly contentClassificationFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"useContentClassification_content">;
      } | null;
      readonly contentProperties: {
        readonly draft: {
          readonly contentMode: string | null;
        } | null;
        readonly latest: {
          readonly contentMode: string | null;
          readonly generatedBy?: string | null;
        } | null;
      } | null;
      readonly contentState: {
        readonly color: string;
        readonly id: string | null;
        readonly name: string;
        readonly restrictionLevel: ContentStateRestrictionLevel;
      } | null;
      readonly contentStateLastUpdated: {
        readonly value: string;
      } | null;
      readonly contentTitleWithByLine?: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentTitleWithByLine_content">;
      } | null;
      readonly coverPicture?: {
        readonly coverPictureProperties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly id: string | null;
      } | null;
      readonly draftVersion: {
        readonly by: {
          readonly displayName: string | null;
        } | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
      readonly history?: {
        readonly createdBy: {
          readonly displayName: string | null;
        } | null;
        readonly createdDate: string | null;
      } | null;
      readonly id: string | null;
      readonly labels?: {
        readonly count: number | null;
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly label: string | null;
          readonly name: string | null;
          readonly prefix: string | null;
        } | null> | null;
      } | null;
      readonly macroRenderedOutput?: ReadonlyArray<{
        readonly key: string | null;
        readonly value: {
          readonly representation: string | null;
          readonly value: string | null;
          readonly webresource: {
            readonly tags: {
              readonly css: string | null;
              readonly js: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
      readonly metadata: {
        readonly frontend: {
          readonly collabService: string | null;
          readonly coverPictureWidth?: string | null;
          readonly embedded: boolean;
          readonly fabricEditorSupported: boolean | null;
        } | null;
        readonly lastModifiedDate: string | null;
      };
      readonly operations: ReadonlyArray<{
        readonly operation: string | null;
        readonly targetType: string | null;
      } | null> | null;
      readonly pageRestrictionsContext?: {
        readonly hasInheritedRestrictions: boolean;
        readonly hasRestrictions: boolean;
        readonly hasViewRestrictions: boolean;
        readonly id: string | null;
      } | null;
      readonly pageRestrictionsContextAncestors?: {
        readonly ancestors: ReadonlyArray<{
          readonly hasRestrictions: boolean;
          readonly id: string | null;
          readonly links: {
            readonly webui: string | null;
          } | null;
          readonly title: string | null;
        } | null> | null;
        readonly id: string | null;
      } | null;
      readonly pageTitlePublished?: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
          readonly version: {
            readonly number: number | null;
          } | null;
        } | null> | null;
      } | null;
      readonly reactionsContent?: {
        readonly contentReactionsSummary: {
          readonly ari: string;
          readonly containerAri: string;
          readonly reactionsCount: number;
          readonly reactionsSummaryForEmoji: ReadonlyArray<{
            readonly count: number;
            readonly emojiId: string;
            readonly id: string;
            readonly reacted: boolean;
          } | null>;
        } | null;
        readonly id: string | null;
      } | null;
      readonly reactionsContentFragment?: {
        readonly " $fragmentSpreads": FragmentRefs<"ReactionsContentFragment_content">;
      } | null;
      readonly rendererCoverPicture?: {
        readonly " $fragmentSpreads": FragmentRefs<"CoverPictureQuery_content">;
      } | null;
      readonly rendererTitleContentProperties?: {
        readonly " $fragmentSpreads": FragmentRefs<"useTitleContentPropertiesForPublishedPage_content">;
      } | null;
      readonly shareAndRestrictButtonData?: {
        readonly hasInheritedRestrictions: boolean;
        readonly hasRestrictions: boolean;
        readonly hasViewRestrictions: boolean;
        readonly id: string | null;
        readonly title: string | null;
      } | null;
      readonly smartFolderProperties: {
        readonly nodes: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly space: {
        readonly alias: string | null;
        readonly id: string | null;
        readonly key: string | null;
        readonly name: string | null;
      } | null;
      readonly status: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly titleContentProperties?: {
        readonly id: string | null;
        readonly metadata: {
          readonly frontend: {
            readonly coverPictureWidth: string | null;
          } | null;
        };
        readonly pageTitleDraft: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly pageTitlePublished: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
      readonly type: string | null;
      readonly version: {
        readonly by: {
          readonly displayName: string | null;
        } | null;
        readonly confRev: string | null;
        readonly contentTypeModified: boolean | null;
        readonly friendlyWhen: string | null;
        readonly number: number | null;
        readonly when: string | null;
      } | null;
      readonly viewPageContentMode?: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentModeFragmentProvider_content">;
      } | null;
      readonly viewPageLabels?: {
        readonly " $fragmentSpreads": FragmentRefs<"ViewPageLabelsContentFragment_content">;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"ContentOperationsFragment" | "PageStatusQueryRelaySpike_content" | "PresenterModePortal_content">;
    } | null> | null;
  } | null;
  readonly contentContributors?: {
    readonly " $fragmentSpreads": FragmentRefs<"ByLineContributors_contentContributors">;
  } | null;
  readonly space: {
    readonly currentUser: {
      readonly isAnonymouslyAuthorized: boolean;
    };
    readonly id: string | null;
    readonly lookAndFeel: {
      readonly content: {
        readonly container: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly borderRadius: string | null;
          readonly padding: string | null;
        } | null;
        readonly screen: {
          readonly background: string | null;
          readonly backgroundAttachment: string | null;
          readonly backgroundBlendMode: string | null;
          readonly backgroundClip: string | null;
          readonly backgroundColor: string | null;
          readonly backgroundImage: string | null;
          readonly backgroundOrigin: string | null;
          readonly backgroundPosition: string | null;
          readonly backgroundRepeat: string | null;
          readonly backgroundSize: string | null;
          readonly gutterBottom: string | null;
          readonly gutterLeft: string | null;
          readonly gutterRight: string | null;
          readonly gutterTop: string | null;
          readonly layer: {
            readonly background: string | null;
            readonly backgroundAttachment: string | null;
            readonly backgroundBlendMode: string | null;
            readonly backgroundClip: string | null;
            readonly backgroundColor: string | null;
            readonly backgroundImage: string | null;
            readonly backgroundOrigin: string | null;
            readonly backgroundPosition: string | null;
            readonly backgroundRepeat: string | null;
            readonly backgroundSize: string | null;
            readonly height: string | null;
            readonly width: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    readonly settings: {
      readonly routeOverrideEnabled: boolean | null;
    } | null;
    readonly theme: {
      readonly name: string | null;
      readonly themeKey: string | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ContentContainerTheme_space" | "ContentTitle_space">;
  } | null;
};
export type ContentBlogUnifiedQuery = {
  response: ContentBlogUnifiedQuery$data;
  variables: ContentBlogUnifiedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bylineContributorsLimit"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAgentTrustReceiptData"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeArchiveMetadata"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeBylineContributors"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeClassification"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeReactions"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictionAncestors"
},
v8 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeRestrictions"
},
v9 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSSR"
},
v10 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "preloadLabels"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v12 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useContentModeFragment"
},
v13 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "useNewContentTopper"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionOverride"
},
v15 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "contentId"
},
v16 = [
  (v15/*: any*/),
  {
    "kind": "Variable",
    "name": "version",
    "variableName": "versionOverride"
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = {
  "kind": "ScalarField",
  "name": "status"
},
v19 = [
  {
    "kind": "ScalarField",
    "name": "contentMode"
  }
],
v20 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": (v19/*: any*/)
    },
    {
      "concreteType": "DraftContentProperties",
      "kind": "LinkedField",
      "name": "draft",
      "plural": false,
      "selections": (v19/*: any*/)
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "name"
},
v22 = {
  "kind": "ScalarField",
  "name": "color"
},
v23 = {
  "args": [
    {
      "kind": "Literal",
      "name": "isDraft",
      "value": false
    }
  ],
  "concreteType": "ContentState",
  "kind": "LinkedField",
  "name": "contentState",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    {
      "kind": "ScalarField",
      "name": "restrictionLevel"
    }
  ],
  "storageKey": "contentState(isDraft:false)"
},
v24 = {
  "kind": "ScalarField",
  "name": "value"
},
v25 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "USER_FRIENDLY"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "contentStateLastUpdated",
  "plural": false,
  "selections": [
    (v24/*: any*/)
  ],
  "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
},
v26 = {
  "kind": "ScalarField",
  "name": "title"
},
v27 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "key"
},
v29 = {
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v21/*: any*/),
    (v28/*: any*/),
    {
      "kind": "ScalarField",
      "name": "alias"
    }
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "type"
},
v31 = {
  "kind": "ScalarField",
  "name": "subType"
},
v32 = [
  (v28/*: any*/),
  (v24/*: any*/)
],
v33 = {
  "alias": "smartFolderProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": (v32/*: any*/)
    }
  ],
  "storageKey": "properties(keys:[\"smartFolderProperties\"])"
},
v34 = {
  "kind": "ScalarField",
  "name": "contentTypeModified"
},
v35 = {
  "kind": "ScalarField",
  "name": "number"
},
v36 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v37 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v38 = [
  (v37/*: any*/)
],
v39 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v38/*: any*/)
},
v40 = {
  "kind": "ScalarField",
  "name": "when"
},
v41 = {
  "kind": "ScalarField",
  "name": "confRev"
},
v42 = [
  {
    "kind": "ScalarField",
    "name": "coverPictureWidth"
  }
],
v43 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "fabricEditorSupported"
        },
        {
          "kind": "ScalarField",
          "name": "embedded"
        },
        {
          "kind": "ScalarField",
          "name": "collabService"
        },
        {
          "condition": "useNewContentTopper",
          "kind": "Condition",
          "passingValue": true,
          "selections": (v42/*: any*/)
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    }
  ]
},
v44 = {
  "kind": "ScalarField",
  "name": "representation"
},
v45 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    (v35/*: any*/)
  ]
},
v46 = {
  "concreteType": "WebResourceTags",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "js"
    },
    {
      "kind": "ScalarField",
      "name": "css"
    }
  ]
},
v47 = [
  (v46/*: any*/)
],
v48 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentBody",
      "kind": "LinkedField",
      "name": "dynamic",
      "plural": false,
      "selections": [
        (v44/*: any*/),
        (v24/*: any*/),
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v17/*: any*/),
            (v45/*: any*/)
          ]
        },
        {
          "concreteType": "WebResourceDependencies",
          "kind": "LinkedField",
          "name": "webresource",
          "plural": false,
          "selections": [
            {
              "concreteType": "SuperBatchWebResources",
              "kind": "LinkedField",
              "name": "superbatch",
              "plural": false,
              "selections": (v47/*: any*/)
            },
            (v46/*: any*/)
          ]
        }
      ]
    }
  ]
},
v49 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v17/*: any*/),
      (v28/*: any*/),
      (v24/*: any*/),
      (v45/*: any*/)
    ]
  }
],
v50 = {
  "alias": "appearancePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "content-appearance-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "properties(key:\"content-appearance-published\")"
},
v51 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-published",
        "emoji-title-published",
        "editor",
        "import-source",
        "imported-page-modified-date"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
},
v52 = {
  "concreteType": "ArchivedContentMetadata",
  "kind": "LinkedField",
  "name": "archivedContentMetadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "archiveNote"
    }
  ]
},
v53 = [
  {
    "kind": "ScalarField",
    "name": "accountId"
  }
],
v54 = {
  "kind": "InlineFragment",
  "selections": (v53/*: any*/),
  "type": "KnownUser"
},
v55 = {
  "kind": "InlineFragment",
  "selections": (v53/*: any*/),
  "type": "UnknownUser"
},
v56 = {
  "alias": "pageTitlePublished",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-published"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "properties(key:\"page-title-property-published\")"
},
v57 = {
  "alias": "pageTitleDraft",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "page-title-property-draft"
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "properties(key:\"page-title-property-draft\")"
},
v58 = {
  "concreteType": "ContentMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
      "kind": "LinkedField",
      "name": "frontend",
      "plural": false,
      "selections": (v42/*: any*/)
    }
  ]
},
v59 = {
  "alias": "coverPictureProperties",
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "cover-picture-id-draft",
        "cover-picture-id-published"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v49/*: any*/),
  "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
},
v60 = {
  "kind": "ScalarField",
  "name": "hasInheritedRestrictions"
},
v61 = {
  "kind": "ScalarField",
  "name": "hasRestrictions"
},
v62 = {
  "kind": "ScalarField",
  "name": "hasViewRestrictions"
},
v63 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASCENDING",
      "sortField": "LABELLING_CREATIONDATE"
    }
  }
],
v64 = {
  "kind": "ScalarField",
  "name": "count"
},
v65 = {
  "kind": "ScalarField",
  "name": "label"
},
v66 = {
  "kind": "ScalarField",
  "name": "prefix"
},
v67 = {
  "concreteType": "ReactionsSummaryResponse",
  "kind": "LinkedField",
  "name": "contentReactionsSummary",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        (v64/*: any*/),
        {
          "kind": "ScalarField",
          "name": "reacted"
        },
        (v17/*: any*/)
      ]
    }
  ]
},
v68 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "ancestors",
  "plural": true,
  "selections": [
    (v17/*: any*/),
    (v26/*: any*/),
    (v61/*: any*/),
    {
      "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "webui"
        }
      ]
    }
  ]
},
v69 = {
  "concreteType": "ClassificationLevelDetails",
  "kind": "LinkedField",
  "name": "classificationLevelDetails",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentDataClassificationLevel",
      "kind": "LinkedField",
      "name": "classificationLevel",
      "plural": false,
      "selections": [
        (v17/*: any*/),
        {
          "kind": "ScalarField",
          "name": "guideline"
        },
        {
          "kind": "ScalarField",
          "name": "guidelineADF"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        (v22/*: any*/),
        (v21/*: any*/),
        (v18/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "featureEnabled"
    },
    {
      "kind": "ScalarField",
      "name": "source"
    },
    {
      "kind": "ScalarField",
      "name": "isReclassificationPermitted"
    },
    {
      "kind": "ScalarField",
      "name": "canManageSpaceSettings"
    },
    {
      "kind": "ScalarField",
      "name": "classificationControlSetting"
    },
    {
      "kind": "ScalarField",
      "name": "userOverrideSetting"
    }
  ]
},
v70 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v71 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "generatedBy"
        }
      ]
    }
  ]
},
v72 = {
  "condition": "isSSR",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "MapOfStringToFormattedBody",
      "kind": "LinkedField",
      "name": "macroRenderedOutput",
      "plural": true,
      "selections": [
        (v28/*: any*/),
        {
          "concreteType": "FormattedBody",
          "kind": "LinkedField",
          "name": "value",
          "plural": false,
          "selections": [
            (v24/*: any*/),
            (v44/*: any*/),
            {
              "concreteType": "WebResourceDependencies",
              "kind": "LinkedField",
              "name": "webresource",
              "plural": false,
              "selections": (v47/*: any*/)
            }
          ]
        }
      ]
    }
  ]
},
v73 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v74 = {
  "kind": "ScalarField",
  "name": "themeKey"
},
v75 = {
  "kind": "ScalarField",
  "name": "background"
},
v76 = {
  "kind": "ScalarField",
  "name": "backgroundColor"
},
v77 = {
  "kind": "ScalarField",
  "name": "backgroundImage"
},
v78 = {
  "kind": "ScalarField",
  "name": "backgroundPosition"
},
v79 = {
  "kind": "ScalarField",
  "name": "backgroundSize"
},
v80 = {
  "kind": "ScalarField",
  "name": "backgroundRepeat"
},
v81 = {
  "kind": "ScalarField",
  "name": "backgroundOrigin"
},
v82 = {
  "kind": "ScalarField",
  "name": "backgroundClip"
},
v83 = {
  "kind": "ScalarField",
  "name": "backgroundAttachment"
},
v84 = {
  "kind": "ScalarField",
  "name": "backgroundBlendMode"
},
v85 = {
  "concreteType": "ScreenLookAndFeel",
  "kind": "LinkedField",
  "name": "screen",
  "plural": false,
  "selections": [
    (v75/*: any*/),
    (v76/*: any*/),
    (v77/*: any*/),
    (v78/*: any*/),
    (v79/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v82/*: any*/),
    (v83/*: any*/),
    (v84/*: any*/),
    {
      "concreteType": "LayerScreenLookAndFeel",
      "kind": "LinkedField",
      "name": "layer",
      "plural": false,
      "selections": [
        (v75/*: any*/),
        (v76/*: any*/),
        (v77/*: any*/),
        (v78/*: any*/),
        (v79/*: any*/),
        (v80/*: any*/),
        (v81/*: any*/),
        (v82/*: any*/),
        (v83/*: any*/),
        (v84/*: any*/),
        {
          "kind": "ScalarField",
          "name": "width"
        },
        {
          "kind": "ScalarField",
          "name": "height"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "gutterTop"
    },
    {
      "kind": "ScalarField",
      "name": "gutterRight"
    },
    {
      "kind": "ScalarField",
      "name": "gutterBottom"
    },
    {
      "kind": "ScalarField",
      "name": "gutterLeft"
    }
  ]
},
v86 = {
  "kind": "ScalarField",
  "name": "padding"
},
v87 = {
  "kind": "ScalarField",
  "name": "borderRadius"
},
v88 = {
  "concreteType": "ContainerLookAndFeel",
  "kind": "LinkedField",
  "name": "container",
  "plural": false,
  "selections": [
    (v75/*: any*/),
    (v76/*: any*/),
    (v77/*: any*/),
    (v78/*: any*/),
    (v79/*: any*/),
    (v80/*: any*/),
    (v81/*: any*/),
    (v82/*: any*/),
    (v83/*: any*/),
    (v84/*: any*/),
    (v86/*: any*/),
    (v87/*: any*/)
  ]
},
v89 = {
  "concreteType": "SpaceSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "routeOverrideEnabled"
    }
  ]
},
v90 = {
  "concreteType": "SpaceUserMetadata",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isAnonymouslyAuthorized"
    }
  ]
},
v91 = [
  (v15/*: any*/),
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "bylineContributorsLimit"
  }
],
v92 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v93 = [
  (v92/*: any*/),
  (v37/*: any*/)
],
v94 = {
  "kind": "LinkedField",
  "name": "by",
  "plural": false,
  "selections": (v93/*: any*/)
},
v95 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v96 = [
  (v92/*: any*/),
  (v30/*: any*/),
  (v37/*: any*/),
  (v54/*: any*/),
  (v95/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ContentBlogUnifiedQuery",
    "selections": [
      {
        "args": (v16/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v17/*: any*/),
              (v18/*: any*/),
              (v20/*: any*/),
              (v23/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v33/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/)
                ]
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": [
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v39/*: any*/),
                  (v40/*: any*/)
                ]
              },
              (v43/*: any*/),
              (v48/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "ContentOperationsFragment"
              },
              {
                "kind": "FragmentSpread",
                "name": "PageStatusQueryRelaySpike_content"
              },
              {
                "kind": "FragmentSpread",
                "name": "PresenterModePortal_content"
              },
              {
                "condition": "includeArchiveMetadata",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ArchivedPageBannerV2Status_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "archivedPageBannerStatusFragment"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ArchivedPageBannerV2_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "archivedPageBannerFragment"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v17/*: any*/),
                        (v30/*: any*/),
                        (v27/*: any*/),
                        (v52/*: any*/),
                        {
                          "concreteType": "History",
                          "kind": "LinkedField",
                          "name": "history",
                          "plural": false,
                          "selections": [
                            {
                              "concreteType": "Version",
                              "kind": "LinkedField",
                              "name": "lastUpdated",
                              "plural": false,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "name": "by",
                                  "plural": false,
                                  "selections": [
                                    (v54/*: any*/),
                                    (v55/*: any*/)
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "archivedPageBanner"
                  }
                ]
              },
              {
                "condition": "useContentModeFragment",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ContentModeFragmentProvider_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "viewPageContentMode"
                  }
                ]
              },
              {
                "condition": "includeBylineContributors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": [
                            {
                              "kind": "Variable",
                              "name": "useNewContentTopper",
                              "variableName": "useNewContentTopper"
                            }
                          ],
                          "kind": "FragmentSpread",
                          "name": "ContentTitleWithByLine_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentTitleWithByLine"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "useTitleContentPropertiesForPublishedPage_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "rendererTitleContentProperties"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "CoverPictureQuery_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "rendererCoverPicture"
                  }
                ]
              },
              {
                "condition": "useNewContentTopper",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v17/*: any*/),
                        (v56/*: any*/),
                        (v57/*: any*/),
                        (v58/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "titleContentProperties"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v17/*: any*/),
                        (v59/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "coverPicture"
                  },
                  (v56/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v17/*: any*/),
                        (v60/*: any*/),
                        (v61/*: any*/),
                        (v62/*: any*/),
                        (v26/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "shareAndRestrictButtonData"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v17/*: any*/),
                        (v60/*: any*/),
                        (v62/*: any*/),
                        (v61/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "pageRestrictionsContext"
                  }
                ]
              },
              {
                "condition": "preloadLabels",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ViewPageLabelsContentFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "viewPageLabels"
                  },
                  {
                    "args": (v63/*: any*/),
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      (v64/*: any*/),
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          (v65/*: any*/),
                          (v21/*: any*/),
                          (v66/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                  }
                ]
              },
              {
                "condition": "includeReactions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v17/*: any*/),
                        (v67/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "reactionsContent"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "ReactionsContentFragment_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "reactionsContentFragment"
                  }
                ]
              },
              {
                "condition": "includeRestrictionAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v17/*: any*/),
                        (v68/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "pageRestrictionsContextAncestors"
                  }
                ]
              },
              {
                "condition": "includeClassification",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "useContentClassification_content"
                        }
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentClassificationFragment"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        (v17/*: any*/),
                        (v69/*: any*/)
                      ],
                      "type": "Content"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "contentClassification"
                  }
                ]
              },
              {
                "condition": "includeAgentTrustReceiptData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v70/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v38/*: any*/)
                      }
                    ]
                  },
                  (v71/*: any*/)
                ]
              },
              (v72/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v73/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ContentContainerTheme_space"
          },
          {
            "kind": "FragmentSpread",
            "name": "ContentTitle_space"
          },
          (v17/*: any*/),
          {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v74/*: any*/),
              (v21/*: any*/)
            ]
          },
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v85/*: any*/),
                  (v88/*: any*/)
                ]
              }
            ]
          },
          (v89/*: any*/),
          (v90/*: any*/)
        ]
      },
      {
        "condition": "includeBylineContributors",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v91/*: any*/),
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ByLineContributors_contentContributors"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v11/*: any*/),
      (v14/*: any*/),
      (v9/*: any*/),
      (v13/*: any*/),
      (v10/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentBlogUnifiedQuery",
    "selections": [
      {
        "args": (v16/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v17/*: any*/),
              (v30/*: any*/),
              (v27/*: any*/),
              (v18/*: any*/),
              (v26/*: any*/),
              (v51/*: any*/),
              (v20/*: any*/),
              (v23/*: any*/),
              (v25/*: any*/),
              (v29/*: any*/),
              (v31/*: any*/),
              (v33/*: any*/),
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v94/*: any*/),
                  (v40/*: any*/),
                  (v41/*: any*/)
                ]
              },
              {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "draftVersion",
                "plural": false,
                "selections": [
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  (v94/*: any*/),
                  (v40/*: any*/)
                ]
              },
              (v43/*: any*/),
              (v48/*: any*/),
              (v50/*: any*/),
              {
                "condition": "includeArchiveMetadata",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v52/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "lastUpdated",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                              (v92/*: any*/),
                              (v54/*: any*/),
                              (v55/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "includeBylineContributors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "emojiTitlePublished",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "key",
                        "value": "emoji-title-published"
                      }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": (v49/*: any*/),
                    "storageKey": "properties(key:\"emoji-title-published\")"
                  },
                  {
                    "alias": "editorProperty",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "key",
                        "value": "editor"
                      }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v17/*: any*/),
                          (v28/*: any*/),
                          (v24/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                  },
                  (v58/*: any*/),
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "homepageId"
                      }
                    ]
                  },
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v70/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v96/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": (v96/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastOwnedBy",
                        "plural": false,
                        "selections": (v96/*: any*/)
                      }
                    ]
                  },
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                          (v30/*: any*/),
                          (v95/*: any*/),
                          (v54/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v71/*: any*/),
                  (v56/*: any*/),
                  (v57/*: any*/),
                  (v59/*: any*/)
                ]
              },
              {
                "condition": "useNewContentTopper",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v56/*: any*/),
                  (v57/*: any*/),
                  (v58/*: any*/),
                  (v59/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v60/*: any*/),
                  (v61/*: any*/),
                  (v62/*: any*/)
                ]
              },
              {
                "condition": "preloadLabels",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v63/*: any*/),
                    "concreteType": "PaginatedLabelList",
                    "kind": "LinkedField",
                    "name": "labels",
                    "plural": false,
                    "selections": [
                      (v64/*: any*/),
                      {
                        "concreteType": "Label",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v92/*: any*/),
                          (v17/*: any*/),
                          (v65/*: any*/),
                          (v21/*: any*/),
                          (v66/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                  }
                ]
              },
              {
                "condition": "includeReactions",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v67/*: any*/)
                ]
              },
              {
                "condition": "includeRestrictionAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v68/*: any*/)
                ]
              },
              {
                "condition": "includeClassification",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v69/*: any*/)
                ]
              },
              {
                "condition": "includeAgentTrustReceiptData",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v70/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v93/*: any*/)
                      }
                    ]
                  },
                  (v71/*: any*/)
                ]
              },
              (v72/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v73/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "concreteType": "Theme",
            "kind": "LinkedField",
            "name": "theme",
            "plural": false,
            "selections": [
              (v21/*: any*/),
              (v74/*: any*/)
            ]
          },
          {
            "concreteType": "LookAndFeel",
            "kind": "LinkedField",
            "name": "lookAndFeel",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentLookAndFeel",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v85/*: any*/),
                  (v88/*: any*/),
                  {
                    "concreteType": "ContainerLookAndFeel",
                    "kind": "LinkedField",
                    "name": "header",
                    "plural": false,
                    "selections": [
                      (v75/*: any*/),
                      (v83/*: any*/),
                      (v84/*: any*/),
                      (v82/*: any*/),
                      (v76/*: any*/),
                      (v77/*: any*/),
                      (v81/*: any*/),
                      (v78/*: any*/),
                      (v80/*: any*/),
                      (v79/*: any*/),
                      (v87/*: any*/),
                      (v86/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "MapOfStringToString",
                "kind": "LinkedField",
                "name": "headings",
                "plural": true,
                "selections": (v32/*: any*/)
              }
            ]
          },
          (v17/*: any*/),
          (v89/*: any*/),
          (v90/*: any*/)
        ]
      },
      {
        "condition": "includeBylineContributors",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v91/*: any*/),
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
              (v64/*: any*/),
              {
                "kind": "ScalarField",
                "name": "isCurrentUserContributor"
              },
              {
                "kind": "ScalarField",
                "name": "isOwnerContributor"
              },
              {
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": (v96/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "223eda78868a326c98d9c170d90b5da9",
    "id": "f81cccca472175339690d4ca0972666654dd3e8de06e57b63ed15e6331038a1f",
    "metadata": {},
    "name": "ContentBlogUnifiedQuery",
    "operationKind": "query",
    "text": "query ContentBlogUnifiedQuery($contentId:ID!,$spaceKey:String=null,$versionOverride:Int,$isSSR:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$includeAgentTrustReceiptData:Boolean=false,$includeBylineContributors:Boolean=false,$bylineContributorsLimit:Int,$includeReactions:Boolean=false,$includeRestrictions:Boolean=false,$includeRestrictionAncestors:Boolean=false,$includeClassification:Boolean=false,$includeArchiveMetadata:Boolean=false,$useContentModeFragment:Boolean=false){content(id:$contentId,version:$versionOverride){nodes{...ContentOperationsFragment,...PageStatusQueryRelaySpike_content,...PresenterModePortal_content,id,status,...ArchivedPageBannerV2Status_content@include(if:$includeArchiveMetadata)\n      ...ArchivedPageBannerV2_content@include(if:$includeArchiveMetadata)\n      id@include(if:$includeArchiveMetadata)\n      type@include(if:$includeArchiveMetadata)\n      operations@include(if:$includeArchiveMetadata){operation,targetType}\n      archivedContentMetadata@include(if:$includeArchiveMetadata){archiveNote}\n      history@include(if:$includeArchiveMetadata){lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}},contentProperties{latest{contentMode},draft{contentMode}},...ContentModeFragmentProvider_content@include(if:$useContentModeFragment),contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value},...ContentTitleWithByLine_content_2SjeOj@include(if:$includeBylineContributors)\n      ...useTitleContentPropertiesForPublishedPage_content@include(if:$includeBylineContributors)\n      ...CoverPictureQuery_content@include(if:$includeBylineContributors),title,operations{operation,targetType},space{id,name,key,alias},type,subType,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when,confRev,when@include(if:$includeAgentTrustReceiptData)},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},metadata{frontend{fabricEditorSupported,embedded,collabService,coverPictureWidth@include(if:$useNewContentTopper)},lastModifiedDate},id@include(if:$useNewContentTopper)\n      pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n      pageTitleDraft:properties(key:\"page-title-property-draft\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n      metadata@include(if:$useNewContentTopper){frontend{coverPictureWidth}}\n      coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},id@include(if:$includeRestrictions)\n      hasInheritedRestrictions@include(if:$includeRestrictions)\n      hasRestrictions@include(if:$includeRestrictions)\n      hasViewRestrictions@include(if:$includeRestrictions)\n      title@include(if:$includeRestrictions),...ViewPageLabelsContentFragment_content@include(if:$preloadLabels)\n      labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}},id@include(if:$includeReactions)\n      contentReactionsSummary@include(if:$includeReactions){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}\n      ...ReactionsContentFragment_content@include(if:$includeReactions),id@include(if:$includeRestrictionAncestors)\n      ancestors@include(if:$includeRestrictionAncestors){id,title,hasRestrictions,links{webui}},...useContentClassification_content@include(if:$includeClassification)\n      id@include(if:$includeClassification)\n      classificationLevelDetails@include(if:$includeClassification){classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n      contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},macroRenderedOutput@include(if:$isSSR){key,value{value,representation,webresource{tags{js,css}}}}}},contentContributors(id:$contentId,limit:$bylineContributorsLimit)@include(if:$includeBylineContributors){...ByLineContributors_contentContributors},space(key:$spaceKey){...ContentContainerTheme_space,...ContentTitle_space,id,theme{themeKey,name},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment ArchivedPageBannerV2Status_content on Content{id,status}fragment ArchivedPageBannerV2_content on Content{id,type,operations{operation,targetType},archivedContentMetadata{archiveNote},history{lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}fragment ByLineContributors_contentContributors on ContentContributors{count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}}fragment ByLine_content_2SjeOj on Content{...useReadTime_content,id,type,subType,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},...RendererContentState_content,pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{coverPictureWidth@include(if:$useNewContentTopper)}}}fragment ContentContainerTheme_space on Space{theme{name,themeKey},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}}}fragment ContentModeFragmentProvider_content on Content{id,contentProperties{latest{contentMode},draft{contentMode}}}fragment ContentOperationsFragment on Content{id,type,operations{operation,targetType}}fragment ContentTitleWithByLine_content_2SjeOj on Content{...ContentTitle_content_2SjeOj,...ByLine_content_2SjeOj,...ArchivedPageBannerV2Status_content}fragment ContentTitle_content_2SjeOj on Content{id,type,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},space{id,name,homepageId}}fragment ContentTitle_space on Space{id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}fragment CoverPictureQuery_content on Content{id,coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}fragment PageStatusQueryRelaySpike_content on Content{status}fragment PresenterModePortal_content on Content{title,properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment ReactionsContentFragment_content on Content{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}fragment RendererContentState_content on Content{id,contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value}}fragment ViewPageLabelsContentFragment_content on Content{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}fragment useContentClassification_content on Content{id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useReadTime_content on Content{id,type,body{dynamic{value,representation}},operations{operation,targetType}}fragment useTitleContentPropertiesForPublishedPage_content on Content{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}"
  }
};
})();

(node as any).hash = "00d9eef747cb3ff3e0add885f9eca0bf";

export default node;
